import { render, staticRenderFns } from "./InsLatestNews.vue?vue&type=template&id=232e8111&scoped=true"
import script from "./InsLatestNews.vue?vue&type=script&lang=ts"
export * from "./InsLatestNews.vue?vue&type=script&lang=ts"
import style0 from "./InsLatestNews.vue?vue&type=style&index=0&id=232e8111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e8111",
  null
  
)

export default component.exports